import { render, staticRenderFns } from "./breadtabsheader.vue?vue&type=template&id=34e68703"
import script from "./breadtabsheader.vue?vue&type=script&lang=js"
export * from "./breadtabsheader.vue?vue&type=script&lang=js"
import style0 from "./breadtabsheader.vue?vue&type=style&index=0&id=34e68703&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports